import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import MainNav from '../../blocks/MainNav';
import {NavLink} from 'react-router-dom';
import { Button, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnchorCircleCheck, faArrowLeft, faCheckCircle, faSave, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { notify } from "../../blocks/Notify";
import "./TrainingResultTable.css"

const TYPE_LABELS = {
    byAssignedTests: 'По назначенным тестам',
    byBaseTests: 'По базовым тестам',
    bySpecialTests: 'По специальным тестам',
};
const formatDate = (iso) => {
    if (!iso) return '—';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '—';
    const pad = (n) => String(n).padStart(2, '0');
    return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

const getPercentModifier = (percent) => {
    if (percent >= 80) return 'is-high';
    if (percent >= 50) return 'is-mid';
    return 'is-low';
};

const getStatusText = (row) => {
    if (row.total === 0) return 'Пропущен';
    return row.firstTryCorrect ? 'Правильно' : 'С ошибкой';
};

const getStatusModifier = (row) => {
    if (row.total === 0) return 'empty';
    return row.firstTryCorrect ? 'correct' : 'wrong';
};
const TrainingResultTable = ({ results,t, handleGoBack})=>{
    const tr = (key, fallback) => (typeof t === 'function' ? t(key) : fallback);
    const [openId, setOpenId] = useState(null);
    const toggle = (id) => {
        setOpenId((prev) => (prev === id ? null : id));
    };  
    

    return <>
        <div className="Screen container mx-auto">
            <div className="emp-results-page">
            <div className="emp-results-page__header">
                <h1 className="emp-results-page__title">
                    Сохранённые результаты тренировок
                </h1>
            </div>

            {(!Array.isArray(results) || results.length === 0) ? (
                <div className="emp-results emp-results_empty">
                    Нет результатов
                </div>
            ) : (
            <div className="emp-results">
            {results.map((item) => {
                const { id, created_dt, stat = {}, result = [] } = item;

                const isOpen = openId === id;
                const typeLabel = TYPE_LABELS[stat.type] || stat.type || '—';
                const totalTasks = result.length;
                const percent = stat.percent ?? 0;
                const percentMod = getPercentModifier(percent);

                return (
                    <div
                        key={id}
                        className={`emp-results__item ${isOpen ? 'is-open' : ''}`}
                    >
                        {/* --- Заголовок (кликабельный) --- */}
                        <button
                            type="button"
                            className="emp-results__header"
                            onClick={() => toggle(id)}
                            aria-expanded={isOpen}
                        >
                            <span className="emp-results__arrow">▸</span>

                            <span className="emp-results__col emp-results__col-date">
                                {formatDate(created_dt)}
                            </span>

                            <span className="emp-results__col emp-results__col-type">
                                {typeLabel}
                            </span>

                            <span className="emp-results__col emp-results__col-duration">
                                {stat.totalDuration || '0:00'}
                            </span>

                            <span
                                className={`emp-results__col emp-results__col-percent ${percentMod}`}
                            >
                                {percent}%
                            </span>
                        </button>

                        {/* --- Раскрывающаяся часть --- */}
                        {isOpen && (
                            <div className="emp-results__body">
                                <div className="emp-results__metrics">
                                    <div className="emp-results__metric">
                                        <div className="emp-results__metric-label">
                                            Всего задач
                                        </div>
                                        <div className="emp-results__metric-value">
                                            {totalTasks}
                                        </div>
                                    </div>

                                    <div className="emp-results__metric emp-results__metric_correct">
                                        <div className="emp-results__metric-label">
                                            Без ошибок
                                        </div>
                                        <div className="emp-results__metric-value">
                                            {stat.correctCount ?? 0}
                                        </div>
                                    </div>

                                    <div className="emp-results__metric emp-results__metric_wrong">
                                        <div className="emp-results__metric-label">
                                            С ошибкой
                                        </div>
                                        <div className="emp-results__metric-value">
                                            {stat.wrongCount ?? 0}
                                        </div>
                                    </div>

                                    <div className="emp-results__metric emp-results__metric_empty">
                                        <div className="emp-results__metric-label">
                                            Пропущено
                                        </div>
                                        <div className="emp-results__metric-value">
                                            {stat.unansweredCount ?? 0}
                                        </div>
                                    </div>
                                </div>

                                {result.length > 0 && (
                                    <div className="emp-results__table-wrap">
                                        <table className="emp-results__table">
                                            <thead>
                                                <tr>
                                                    <th className="emp-results__col-num">#</th>
                                                    <th>Вопрос</th>
                                                    <th className="emp-results__col-attempts">
                                                        Попыток
                                                    </th>
                                                    <th className="emp-results__col-time">
                                                        Время
                                                    </th>
                                                    <th className="emp-results__col-status">
                                                        Итог
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {result.map((r, i) => (
                                                    <tr key={`${r.questionId}-${i}`}>
                                                        <td className="emp-results__col-num">
                                                            {i + 1}
                                                        </td>
                                                        <td
                                                            className="emp-results__col-question"
                                                            title={r.questionText}
                                                        >
                                                            {r.questionText}
                                                        </td>
                                                        <td className="emp-results__col-attempts">
                                                            {r.total}
                                                        </td>
                                                        <td className="emp-results__col-time">
                                                            {r.questionDuration}
                                                        </td>
                                                        <td className="emp-results__col-status">
                                                            <span
                                                                className={`emp-results__status emp-results__status_${getStatusModifier(r)}`}
                                                            >
                                                                {getStatusText(r)}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
            )}
        </div>
        </div>
         <MainNav>
            <Container className={`d-flex justify-content-between`}>                
                <Button onClick={()=>{handleGoBack()}} className={`Btn Btn_success MuiButton`}>
                                        <FontAwesomeIcon className="mr-4" icon={faArrowLeft}/>
                                        <span>{tr('Go to back', 'Вернуться назад')}</span>
                                    </Button>
                
                <NavLink to={"/"} className={`Btn Btn_danger MuiButton`}>
                    <FontAwesomeIcon className="mr-4" icon={faSignOutAlt}/>
                    <span>{tr('Exit','Выйти')}</span>
                </NavLink>
            </Container>
        </MainNav>
    </>
}

export default withTranslation()(TrainingResultTable);